import type { TranslateFunction } from '@locus-taxy/encore-i18n-toolkit';

/**
 * A stored gender value's localised label, or the value itself when this page has none. Literal
 * keys, so the locale catalog sync can find them.
 */
export function getGenderLabel(t: TranslateFunction, value: string) {
  switch (value) {
    case 'MALE':
      return t('dashboard.userDetails.gender.male', 'Male');
    case 'FEMALE':
      return t('dashboard.userDetails.gender.female', 'Female');
    case 'OTHER':
      return t('dashboard.userDetails.gender.other', 'Other');
    case 'UNDISCLOSED':
      return t('dashboard.userDetails.gender.undisclosed', 'Undisclosed');
    default:
      return value;
  }
}

/**
 * Gender select options for the profile form: the values the backend read off the person entity's
 * schema, with localised labels.
 */
export function getGenderOptions(
  t: TranslateFunction,
  values: readonly string[]
) {
  return values.map(value => ({ label: getGenderLabel(t, value), value }));
}

export const PHOTO_MAX_SIZE_BYTES = 1_048_576; // 1MB
export const PHOTO_ACCEPTED_TYPES = ['image/jpeg', 'image/png'];
